import { WorkbookService } from '@workbook/workbook.service';
import { AppService } from '@base/app.service';
import { UserService } from '@user/user.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { IUser, IWorkbook, ITag } from '@interfaces';
import { EMPTY } from '@utils';
import { ICompany } from '@base/company/company.structures';
import { Subscription, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { FilterWorkbookComponent } from '@base/tableau-dashboard/tableau-filter-workbook/tableau-filter-workbook.component';
import { Router } from '@angular/router';
import { TableauService } from '@base/tableau/tableau.service';
import { faFileExcel, faFilePdf, faFileImage, faWindowRestore } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'app-tableau-dashboard',
  templateUrl: './tableau-dashboard.component.html',
  styleUrls: ['./tableau-dashboard.component.sass']
})
export class TableauDashboardComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[];
  workbooks: [];
  targetUrl = '';
  showEmbed = false;
  embeddWorkbook = '';
  imagePath = '';
  imageToShow: any;
  isImageLoading: boolean;
  user: IUser;
  company: ICompany;
  imgWorkbook = '/assets/workbook_image.png';
  workbook: IWorkbook;
  locationNavigate = Location;
  companyTags: ITag[];
  processingData: Observable<boolean>;
  showExportToolbar: Observable<boolean>;
  showNavBackButton: Observable<boolean>;
  showTags: Observable<boolean>;

  faFileExcel = faFileExcel;
  faFilePdf = faFilePdf;
  faFileImage = faFileImage;
  faWindowRestore = faWindowRestore;

  constructor(
    private userService: UserService,
    private mainService: AppService,
    private dialog: MatDialog,
    private workbookService: WorkbookService,
    private location: Location,
    private router: Router,
    private tableauService: TableauService,
  ) {
    this.isImageLoading = false;
    this.subscriptions = [];
    this.companyTags = [];
    this.user = EMPTY;
    this.company = EMPTY;
    this.workbooks = [];
    this.workbook = EMPTY;

    const companySubscription: Subscription = this.mainService.getCurrentCompany().subscribe(
      (res: ICompany) => {this.company = res; },
      err => console.error(`Ocurrio un error: ${err.message}`)
    );

    const currentUserSubscription: Subscription = this.mainService.getCurrentUser().subscribe(
      (res: IUser) => {this.user = res; },
      err => console.error(`Ocurrio un error: ${err.message}`)
    );

    this.processingData = this.workbookService.observeProcessingData();
    this.showExportToolbar = this.mainService.obsStatusExportToolbar();
    this.showNavBackButton = this.tableauService.observeNavBackButton();
    this.showTags = this.tableauService.displayTags();

    const workbookSubscription: Subscription = this.workbookService.observeWorkbookSelected().subscribe(
      (wb: IWorkbook) => {this.workbook = wb; },
      err => console.error(`Ocurrio un error: ${err.message}`)
    );

    const userTagsSubs: Subscription = this.userService.observeAllowedTags().pipe(
      map((c: []) => {
        const fixedArray = c.map((e: Object) => {
          return {id: e['id'], name: e['name'], selected: false, };
        });
        return [{id: 0, name: 'Todos', selected: true}].concat(fixedArray);
      })
    )
    .subscribe(
      (tags: []) => this.companyTags = tags
    );

    this.subscriptions = [...this.subscriptions,
      currentUserSubscription, companySubscription, workbookSubscription, userTagsSubs,
    ];
  }

  ngOnInit() {
    if (this.user !== EMPTY && (this.company !== EMPTY && typeof this.company !== 'undefined')) {
      this.userService.getWorkbooks(this.user, this.company);
    }
  }

  ngOnDestroy() {
    this.subscriptions.map((s: Subscription) => s.unsubscribe());
  }

  openWorkbook(w) {
    this.isImageLoading = true;

  }

  openAdvancedFilter() {
    console.log('openAdvancedFilter');
    const data = {
      // workbook: w,
      // user: this.user,
    };
    const dialogRef = this.dialog.open(FilterWorkbookComponent, {
      width: '370px',
      data: data,
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe(
      (url: string) => {
        // if (url) {
        //   this.workbookService.setFinalUrl(url);
        //   this.router.navigate(['/home/panels/tableau/', w.id]);
        // }
      },
      (err) => {console.log(err); }
    );
  }

  generateData(format: string) {
    this.workbookService.exportData(format);
  }

  goBack() {
    this.location.back();
  }

  goHome() {
    this.workbookService.setWorkbook(EMPTY);
    this.router.navigate(['/home/panels/tableau']);
  }

  toggleFullScreen() {
    const elem = document.getElementById('vizContainer');
    this.mainService.setFullScreenRequest(true);

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    }
  }

  filterWorkbooks(t: ITag) {
    const auxCompanyTags = [...this.companyTags] as [];

    if (this.companyTags.length) {
      auxCompanyTags.map((tt: Object) => {
        tt['selected'] = (tt['id'] === t['id']);
      });
      this.companyTags = auxCompanyTags;

      this.userService.filterWorkbooksByTag(t);
    }
  }
}
